const getType = (index, array) => {
  const typeAll = {
    'frdbz': '单位介绍信或法人代表证明书、委托授权书。(原件)',
    'lyzsf': '利用者身份证(正反面)或工作证复印件，加盖单位公章(验原件，留复印件)',
    'cjhty': '参建合同原件或加盖建设单位公章的复印件。(验原件，留复印件)',
    'jzwmc': '建筑物名称与建设项目报建名称不一致的，需要提供建筑物更名文件原件或加盖建设单位公章的复印件。(验原件，留复印件)',
    'gsday': '公司档案移交进馆之后已经更名的，需要提交工商部门的更名文件原件或加盖建设单位公章的复印件。(验原件，留复印件)',
    'jbrsc': '经办人手持身份证照片',
    'cqdwc': '产权单位/产权人提供房产证或与产权相关证明文件(原件在银行抵押的需提供加盖有银行专用抵押证明章的有效复印件或银行抵押合同，也可以提供国土部门出具的产权信息登记表)。(验原件，留复印件)',
    'cqdwj': '产权单位介绍信或授权委托书，明确注明利用者的身份及利用档案的目的和范围。(验原件，留复印件)',
    'wtqtr': '委托其他人，须提供委托人身份证原件、受委托人身份证原件，及委托授权书。(身份证验原件，留复印件；公证委托书验原件，留复印件；其他委托书留原件)',
    'sqwts': '单位介绍信或授权委托书，明确注明利用者的身份及利用档案的目的和范围。(验原件，留复印件)',
    'wyglg': '物业管理公司还须提供与业委会签订的管理期限内委托管理合同或加盖物业管理公司公章的复印件；或者住建局备案文件证明:住建局网站小区物业查询公开信息。没有签订物业管理合同的，提供所在街道证明文件。(验原件，留复印件)',
    'zpgls': '产权单位/产权人提供房产证或与产权相关证明文件(原件在银行抵押的需提供加盖有银行专用抵押证明章的有效复印件或银行抵押合同，也可以提供国土部门出具的产权信息登记表)。(验原件，留复印件)',
    'zpzwg': '租赁管理所出具的房屋租赁备案凭证。(验原件，留复印件)没有租赁备案凭证的，可提供与产权单位/个人的租赁合同，同时必须提供产权单位和产权人的房屋产权证明文件原件。与物业管理公司签订租赁合同的，同时必须提供物业管理公司管理期限内的物管合同原件或加盖建设单位公章的复印件',
    'zpzwd': '租赁者为个人的，提供租赁者身份证。租赁者为单位的，提供租赁单位的工商营业执照、介绍信或授权委托书及委托人身份证；租赁者为单位的，提供租赁单位的工商营业执照、介绍信或授权委托书及委托人身份证。（验原件，留复印件）',
    'jgdwt': '旧改单位提供政府拆迁公告或有关征用土地批文、有关拆除范围内建设项目权属证明。（验原件，留复印件）',
    'pmgst': '拍卖公司提供建设项目的拍卖委托证明。（验原件，留复印件）',
    'dwjsx': '单位介绍信（验原件，留复印件）',
    'zxgwz': '执行公务证件或工作证（验原件，留复印件）',
    'yscyj': '与所查阅建设项目有关的新建项目前期政府审批类文件原件或加盖建设单位印章的审批文件复印件，并与本馆签订保密协议。（验原件，留复印件）',
    'ajlaz': '案件立案证明（立案证明、立案通知书、应诉通知书、受理通知书、起诉意见书、裁定书、传票等）(验原件，留复印件）',
    'wtrdl': '委托人对律师事务所出具的授权委托书（验原件，留复印件）',
    'lssws': '律师事务所介绍信（原件）',
    'lszyz': '律师执业证（验原件，留复印件）',
    'wtqtx': '委托其他人，须提供委托人身份证原件、受委托人身份证原件，及委托授权书'
  }
  return array.map(item => ({
    type: `file${index}_${item.code}`,
    require: item.require || false,
    title: `请上传${typeAll[item.code]}`,
    fileList: [],
    fileCode: []
  }))
}

export const typeImageMap = {
  '1': getType(1, [
    { code: 'frdbz', require: true },
    { code: 'lyzsf', require: true },
    { code: 'cjhty' },
    { code: 'jzwmc' },
    { code: 'gsday' },
    { code: 'jbrsc', require: true }
  ]),
  '2': getType(2, [
    { code: 'cqdwc', require: true },
    { code: 'cqdwj' },
    { code: 'lyzsf', require: true },
    { code: 'wtqtr' },
    { code: 'jbrsc', require: true }
  ]),
  '3': getType(3, [
    { code: 'sqwts', require: true },
    { code: 'wyglg' },
    { code: 'lyzsf', require: true },
    { code: 'jbrsc', require: true }
  ]),
  '4': getType(4, [
    { code: 'zpgls', require: true },
    { code: 'zpzwg' },
    { code: 'zpzwd' },
    { code: 'wtqtx' }
  ]),
  '5': getType(5, [
    { code: 'jgdwt' },
    { code: 'pmgst' },
    { code: 'sqwts', require: true },
    { code: 'lyzsf', require: true },
    { code: 'jbrsc', require: true }
  ]),
  '6': getType(6, [
    { code: 'dwjsx', require: true },
    { code: 'zxgwz', require: true },
    { code: 'jbrsc', require: true }
  ]),
  '7': getType(7, [
    { code: 'yscyj', require: true },
    { code: 'sqwts', require: true },
    { code: 'lyzsf', require: true },
    { code: 'jbrsc', require: true }
  ]),
  '8': getType(8, [
    { code: 'ajlaz', require: true },
    { code: 'wtrdl', require: true },
    { code: 'lssws', require: true },
    { code: 'lszyz', require: true },
    { code: 'jbrsc', require: true }
  ])
}
